import { render, staticRenderFns } from "./mechanism.vue?vue&type=template&id=0e9a36bf&scoped=true&"
import script from "./mechanism.vue?vue&type=script&lang=js&"
export * from "./mechanism.vue?vue&type=script&lang=js&"
import style0 from "./mechanism.vue?vue&type=style&index=0&id=0e9a36bf&lang=scss&scoped=true&"
import style1 from "./mechanism.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9a36bf",
  null
  
)

export default component.exports